import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from './util/constants';
import Index from './routes/index'
import AppointmentIndex from './routes/appointment-status/index'

const AppRouter = (props) => {

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/:chassisNo" element={<Index />} />
                <Route path={ROUTES.INDEX} element={<Index />} />
                <Route path={ROUTES.APPOINTMENT_STATUS + '/:id'} element={<AppointmentIndex />} />

                {/* Default */}
                <Route path="*" element={<Navigate to={ROUTES.DEFAULT} />} />
            </Routes>
        </BrowserRouter>
    );

};

export default AppRouter